import React from 'react';
import { skillsData, toolsTags } from '../../data/skillsData';
import SkillsGrid from '../skills/SkillsGrid';
import ToolsSection from '../skills/ToolsSection';

const Skills = () => {
  const handleTagClick = (tag) => {
    // Tag click handler - no tracking
  };

  return (
    <section className="py-16 px-4 bg-white" id="skills">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <section className="mb-12 pt-4">
          <SkillsGrid skillsData={skillsData} />
          <ToolsSection toolsTags={toolsTags} onTagClick={handleTagClick} />
        </section>
      </div>
    </section>
  );
};

export default Skills;